import React from 'react';

// The award mark — ONE component, used everywhere an award is shown.
//
// "A mark that varies by context stops being a mark" (rollout brief §1), which
// is why this is never pasted inline at a call site. Internal card, supplier
// portal and any future surface all render this exact geometry.
//
// It REPLACES the "Awarded" pill rather than joining it. The net number of
// signals on the awarded card must not go up.
//
// Email is the one place this cannot be used: Outlook strips inline SVG and the
// other clients are inconsistent, so email references a PNG raster instead.

// Below 20px the ribbon tails close up and it reads as a green blob.
export const AWARD_MEDAL_MIN = 20;

export default function AwardMedal({ size = 40, decorative = false, className = '' }) {
  const px = Math.max(AWARD_MEDAL_MIN, Number(size) || AWARD_MEDAL_MIN);
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 48 48"
      className={`flex-shrink-0 block ${className}`}
      role={decorative ? undefined : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : 'Awarded'}
      focusable="false"
    >
      {/* Ribbon tails */}
      <path d="M15 27L11 45l7-4 6 3-4-17z" fill="var(--seal-soft)" />
      <path d="M33 27l4 18-7-4-6 3 4-17z" fill="var(--seal-soft)" />
      {/* Disc */}
      <circle cx="24" cy="20" r="14" fill="var(--seal)" />
      <circle cx="24" cy="20" r="10" fill="none" stroke="var(--seal-soft)" strokeWidth="1.4" />
      {/* The tick is a KNOCKOUT out of the green disc, not a themed surface —
          #FFFFFF stays literal so it can never flip in dark mode. */}
      <path
        d="M18.5 20.5l4 4 7-8"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
